import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    fc_36: {},
    loading: false,
    fc_36Map: {},
    paginaActiva: 1,
    paginaActivaProduccion: 1,
    paginaActivaEnvasado: 1,
    paginaActivaAlmacen: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    modoRevision: false,
    modoVerDetalle: false,
    modoRecibidasCorregidas: false,
    modoProceso: false,
    fc_36MediosContactoMap: [],
    fc_36PersonasAutorizadasMap: [],
    fc_36RepresentanteLegalMap: [],
    fc_36DomicilioFiscalMap: [],
}

//types
const FC_36_DETALLE_EXITO = 'FC_36_DETALLE_EXITO'
const OBTENER_FC_36_MAP_EXITO = 'OBTENER_FC_36_MAP_EXITO'
const OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO'
const OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO'
const OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO'
const FC_36_SOLICITUD_EXITO = 'FC_36_SOLICITUD_EXITO'
const AGREGAR_FC_36_BORRADOR_EXITO = 'AGREGAR_FC_36_BORRADOR_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADALMACEN_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADALMACEN_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADENVASADO_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADENVASADO_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADPRODUCCION_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADPRODUCCION_EXITO'
const ELIMINAR_FC_36_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_36_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_36_ANEXOMARCA_EXITO_BD = 'ELIMINAR_FC_36_ANEXOMARCA_EXITO_BD'
const ELIMINAR_FC_36_ANEXOREPRESENTANTE_EXITO_BD = 'ELIMINAR_FC_36_ANEXOREPRESENTANTE_EXITO_BD'
const ELIMINAR_FC_36_ANEXOCONTACTO_EXITO_BD = 'ELIMINAR_FC_36_ANEXOCONTACTO_EXITO_BD'
const AGREGAR_FC_36_EXITO_MAP = 'AGREGAR_FC_36_EXITO_MAP'
const ACTUALIZAR_FC_36_EXITO_MAP = 'ACTUALIZAR_FC_36_EXITO_MAP'
const ACTUALIZAR_FC_36_ESTATUS_EXITO = 'ACTUALIZAR_FC_36_ESTATUS_EXITO'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const ACTUALIZAR_SOLICITUD_FC36 = 'ACTUALIZAR_SOLICITUD_FC36'
const ACEPTAR_FC_36_EXITO = 'ACEPTAR_FC_36_EXITO'
const GENERAR_OFICIOS_EXITO_FC_36 = 'GENERAR_OFICIOS_EXITO_FC_36'
const OBTENER_CLIENTE_DETALLE_FC_36 = 'OBTENER_CLIENTE_DETALLE_FC_36'
const OBTENER_FOLIO_OFICIO_AT36 = 'OBTENER_FOLIO_OFICIO_AT36'
const ENVIAR_CORREO_EXITO = 'ENVIAR_CORREO_EXITO'
const OBTENER_FC_01_POR_LOGIN_EXITO = 'OBTENER_FC_01_POR_LOGIN_EXITO'
const ACTUALIZAR_FORMULARIO_FC36 = 'ACTUALIZAR_FORMULARIO_FC36'

export const obtenerFC_36SolicitudDetalle = createAsyncThunk(
    FC_36_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_36/obtenerFormatoFC36_ConDetalleMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarMapFC_36Accion = createAsyncThunk(
    AGREGAR_FC_36_EXITO_MAP,
    async (data) => {
        try {

            const observacionPrincipal = { data: data.solicitud[0] }
            const mediosContactoMap = data.mediosContactoMap
            const personasAutorizadasMap = data.personasAutorizadasMap
            const representantesLegalesMap = data.representantesLegalesMap
            const prediosMap = data.prediosMap
            const viveroMap = data.viveroMap
            const marcasMap = data.marcasMap
            const marcasBebidasMap = data.marcasBebidasMap
            const InstalacionesDomicilioMap = data.InstalacionesDomicilioMap
            const InstalacionesResponsablesMap = data.InstalacionesResponsablesMap
            const domiciliosFiscalesMap = data.domiciliosFiscalesMap
            const ResponsablesInstMap = data.ResponsablesInstMap

            const archivosRepresentanteLegalMap = data.archivosRepresentanteLegalMap
            const archivosPersonasAutorizadasMap = data.archivosPersonasAutorizadasMap
            const archivosDomicilioFiscalMap = data.archivosDomicilioFiscalMap
            const archivosPrediosMap = data.archivosPrediosMap
            const archivosViverosMap = data.archivosViverosMap
            const archivosMarcasMap = data.archivosMarcasMap
            const archivosMarcasBebidasMap = data.archivosMarcasBebidasMap
            const archivosInstalacionesMap = data.archivosInstalacionesMap
            const archivosResponsablesInstalacionesMap = data.archivosInstalacionesResponsablesMap
            const archivosResponsablesInstMap = data.archivosResponsablesInstMap

            const agregarFC_36PricipalMap = host + `MapSolicitud/agregarMapFC_36_SolicitudDeActualizacionMap`
            const agregarFC_36MediosContactoMap = host + 'MapSolicitud/agregarMapFC_36_AnexoMediosDeContactoMap'
            const agregarFC_36PersonasAutorizadasMap = host + 'MapSolicitud/agregarMapFC_36_AnexoRepresentantesAutorizadosMap'
            const agregarFC_36RepresentanteLegalMap = host + 'MapSolicitud/agregarMapFC_36_AnexoRepresentantesLegalMap'
            const agregarFC_36PredioMap = host + 'MapSolicitud/agregarFC_36_PredioMap'
            const agregarFC_36ViveroMap = host + 'MapSolicitud/agregarFC_36_ViveroMap'
            const agregarFC_36MarcasMap = host + 'MapSolicitud/agregarFC_36_MarcasMap'
            const agregarFC_36MarcasBebidasMap = host + 'MapSolicitud/agregarFC_36_MarcasBebidasMap'
            const agregarFC_36InformacionGeneralMap = host + 'MapSolicitud/agregarFC_36_InformacionGeneralMap'
            const agregarFC_36ResponsablesInstalacionesMap = host + 'MapSolicitud/agregarFC_36_ResponsableInstalacionMap'
            const agregarFC_36DomicilioFiscalMap = host + 'MapSolicitud/agregarMapFC_36_AnexoDomiciliosFiscalMap'
            const agregarFC_36ResponsablesInstMap = host + 'MapSolicitud/agregarFC_36_ActualizacionResponsablesInstalacionesMap'

            const agregarFC_36ArchivoRepresentanteAutorizadoMap = host + 'MapSolicitud/agregarMapFC_36_ArchivosRepresentantesAutorizadosMap'
            const agregarFC_36ArchivoRepresentanteLegalMap = host + 'MapSolicitud/agregarMapFC_36_ArchivoRepresentantesLegalMap'
            const agregarFC_36ArchivoDomicilioFiscalMap = host + 'MapSolicitud/agregarMapFC_36_ArchivoDomiciliosFiscalMap'
            const agregarFC_36ArchivoPredioMap = host + 'MapSolicitud/agregarFC_36_ArchivosPredioMap'
            const agregarFC_36ArchivoViveroMap = host + 'MapSolicitud/agregarFC_36_ArchivosViveroMap'
            const agregarFC_36ArchivoMarcasMap = host + 'MapSolicitud/agregarFC_36_ArchivosMarcasMap'
            const agregarFC_36ArchivoMarcasBebidasMap = host + 'MapSolicitud/agregarFC_36_ArchivosMarcasBebidasMap'
            const agregarFC_36ArchivoInstalacionesMap = host + 'MapSolicitud/agregarFC_36_ArchivoInstalacionMap'
            const agregarFC_36ArchivoInstalacionesResponsablesMap = host + 'MapSolicitud/agregarFC_36_ArchivosResponsableInstalacionMap'
            const agregarFC_36ArchivoResponsablesInstMap = host + 'MapSolicitud/agregarFC_36_ArchivosActualizacionResponsablesInstalacionesMap'

            const res = await axios.post(agregarFC_36PricipalMap, observacionPrincipal)
            console.log(' al agregar ', res)
            for (const i in mediosContactoMap) {
                await axios.post(agregarFC_36MediosContactoMap, { data: mediosContactoMap[i] })
            }
            for (const i in personasAutorizadasMap) {
                await axios.post(agregarFC_36PersonasAutorizadasMap, { data: personasAutorizadasMap[i] })
            }
            for (const i in representantesLegalesMap) {
                await axios.post(agregarFC_36RepresentanteLegalMap, { data: representantesLegalesMap[i] })
            }
            for (const i in domiciliosFiscalesMap) {
                await axios.post(agregarFC_36DomicilioFiscalMap, { data: domiciliosFiscalesMap[i] })
            }
            for (const i in prediosMap) {
                await axios.post(agregarFC_36PredioMap, { data: prediosMap[i] })
            }
            for (const i in viveroMap) {
                await axios.post(agregarFC_36ViveroMap, { data: viveroMap[i] })
            }
            for (const i in marcasMap) {
                await axios.post(agregarFC_36MarcasMap, { data: marcasMap[i] })
            }
            for (const i in marcasBebidasMap) {
                await axios.post(agregarFC_36MarcasBebidasMap, { data: marcasBebidasMap[i] })
            }
            for (const i in InstalacionesDomicilioMap) {
                await axios.post(agregarFC_36InformacionGeneralMap, { data: InstalacionesDomicilioMap[i] })
            }
            for (const i in InstalacionesResponsablesMap) {
                await axios.post(agregarFC_36ResponsablesInstalacionesMap, { data: InstalacionesResponsablesMap[i] })
            }

            for (const i in archivosRepresentanteLegalMap) {
                await axios.post(agregarFC_36ArchivoRepresentanteLegalMap, { data: archivosRepresentanteLegalMap[i] })
            }
            for (const i in archivosPersonasAutorizadasMap) {
                await axios.post(agregarFC_36ArchivoRepresentanteAutorizadoMap, { data: archivosPersonasAutorizadasMap[i] })
            }
            for (const i in archivosDomicilioFiscalMap) {
                await axios.post(agregarFC_36ArchivoDomicilioFiscalMap, { data: archivosDomicilioFiscalMap[i] })
            }
            for (const i in archivosPrediosMap) {
                await axios.post(agregarFC_36ArchivoPredioMap, { data: archivosPrediosMap[i] })
            }
            for (const i in archivosViverosMap) {
                await axios.post(agregarFC_36ArchivoViveroMap, { data: archivosViverosMap[i] })
            }
            for (const i in archivosMarcasMap) {
                await axios.post(agregarFC_36ArchivoMarcasMap, { data: archivosMarcasMap[i] })
            }
            for (const i in archivosMarcasBebidasMap) {
                await axios.post(agregarFC_36ArchivoMarcasBebidasMap, { data: archivosMarcasBebidasMap[i] })
            }
            for (const i in archivosInstalacionesMap) {
                await axios.post(agregarFC_36ArchivoInstalacionesMap, { data: archivosInstalacionesMap[i] })
            }
            for (const i in archivosResponsablesInstalacionesMap) {
                await axios.post(agregarFC_36ArchivoInstalacionesResponsablesMap, { data: archivosResponsablesInstalacionesMap[i] })
            }
            for (const i in ResponsablesInstMap) {
                await axios.post(agregarFC_36ResponsablesInstMap, { data: ResponsablesInstMap[i] })
            }
            for (const i in archivosResponsablesInstMap) {
                await axios.post(agregarFC_36ArchivoResponsablesInstMap, { data: archivosResponsablesInstMap[i] })
            }
            return true
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_36Solicitud = createAsyncThunk(
    ACTUALIZAR_SOLICITUD_FC36,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosRepresentanteLegal = data.archivosRepresentanteLegal
            const archivosPersonasAutorizadas = data.archivosPersonasAutorizadas
            const archivosDomicilioFiscal = data.archivosDomicilioFiscal
            const archivosPredios = data.archivosPredios
            const archivosViveros = data.archivosViveros
            const archivosMarcas = data.archivosMarcas
            const archivosMarcasBebidas = data.archivosMarcasBebidas
            const archivosInstalaciones = data.archivosInstalaciones
            const archivosInstalacionesResponsables = data.archivosInstalacionesResponsables
            const archivosResponsablesInst = data.archivosResponsablesInst

            const actualizarFC_36 = host + 'FC_36/actualizarSolicitudFC_36'
            const urlActualizarArchivoPersonaAutorizada = host + 'FC_36/actualizarArchivoPersonasAutorizadasFC_36'
            const urlActualizarArchivoRepresentanteLegal = host + 'FC_36/actualizarArchivoRepresentantesLegalesFC_36'
            const urlActualizarArchivoDomicilio = host + 'FC_36/actualizarArchivoDomicilioFiscalFC_36'
            const urlActualizarArchivoPredio = host + 'FC_36/actualizarArchivoPrediosFC_36'
            const urlActualizarArchivoVivero = host + 'FC_36/actualizarArchivoViverosFC_36'
            const urlActualizarArchivoMarca = host + 'FC_36/actualizarFechaArchivoMarca'
            const urlActualizarArchivoMarcaBebidas = host + 'FC_36/actualizarFechaArchivoMarcaBebida'
            const urlActualizarArchivoInstalacion = host + 'FC_36/actualizarFechaArchivoInstalacion'
            const urlActualizarArchivoInstalacionResponsables = host + 'FC_36/actualizarFechaArchivoResponsable'
            const urlActualizarArchivoResponsablesInst = host + 'FC_36/actualizarFechaArchivoActualizacionResponsable'

            //const res = await axios.put(actualizarFC_36, solicitud)
            for (const i in archivosRepresentanteLegal) {
                await axios.put(urlActualizarArchivoRepresentanteLegal, { data: archivosRepresentanteLegal[i] })
            }
            for (const i in archivosPersonasAutorizadas) {
                await axios.put(urlActualizarArchivoPersonaAutorizada, { data: archivosPersonasAutorizadas[i] })
            }
            for (const i in archivosDomicilioFiscal) {
                await axios.put(urlActualizarArchivoDomicilio, { data: archivosDomicilioFiscal[i] })
            }
            for (const i in archivosPredios) {
                await axios.put(urlActualizarArchivoPredio, { data: archivosPredios[i] })
            }
            for (const i in archivosViveros) {
                await axios.put(urlActualizarArchivoVivero, { data: archivosViveros[i] })
            }
            for (const i in archivosMarcas) {
                await axios.put(urlActualizarArchivoMarca, { data: archivosMarcas[i] })
            }
            for (const i in archivosMarcasBebidas) {
                await axios.put(urlActualizarArchivoMarcaBebidas, { data: archivosMarcasBebidas[i] })
            }
            for (const i in archivosInstalaciones) {
                await axios.put(urlActualizarArchivoInstalacion, { data: archivosInstalaciones[i] })
            }
            for (const i in archivosInstalacionesResponsables) {
                await axios.put(urlActualizarArchivoInstalacionResponsables, { data: archivosInstalacionesResponsables[i] })
            }
            for (const i in archivosResponsablesInst) {
                await axios.put(urlActualizarArchivoResponsablesInst, { data: archivosResponsablesInst[i] })
            }

            return data
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarMapFC_36Accion = createAsyncThunk(
    ACTUALIZAR_FC_36_EXITO_MAP,
    async (data) => {
        try {
            const observacionPrincipal = { data: data.solicitud[0] }
            const mediosContactoMap = data.mediosContactoMap
            const personasAutorizadasMap = data.personasAutorizadasMap
            const representantesLegalesMap = data.representantesLegalesMap
            const prediosMap = data.prediosMap
            const viveroMap = data.viveroMap
            const marcasMap = data.marcasMap
            const marcasBebidasMap = data.marcasBebidasMap
            const InstalacionesDomicilioMap = data.InstalacionesDomicilioMap
            const InstalacionesResponsablesMap = data.InstalacionesResponsablesMap
            const domiciliosFiscalesMap = data.domiciliosFiscalesMap
            const ResponsablesInstMap = data.ResponsablesInstMap

            const archivosRepresentanteLegalMap = data.archivosRepresentanteLegalMap
            const archivosPersonasAutorizadasMap = data.archivosPersonasAutorizadasMap
            const archivosDomicilioFiscalMap = data.archivosDomicilioFiscalMap
            const archivosPrediosMap = data.archivosPrediosMap
            const archivosViverosMap = data.archivosViverosMap
            const archivosMarcasMap = data.archivosMarcasMap
            const archivosMarcasBebidasMap = data.archivosMarcasBebidasMap
            const archivosInstalacionesMap = data.archivosInstalacionesMap
            const archivosResponsablesInstalacionesMap = data.archivosInstalacionesResponsablesMap
            const archivosResponsablesInstMap = data.archivosResponsablesInstMap

            const actualizarFC_36PricipalMap = host + `MapSolicitud/actualizarMapFC_36_SolicitudDeActualizacionMap`
            const agregarFC_36MediosContactoMap = host + 'MapSolicitud/agregarMapFC_36_AnexoMediosDeContactoMap'
            const actualizarFC_36MediosContactoMap = host + 'MapSolicitud/actualizarMapFC_36_AnexoMediosDeContactoMap'
            const agregarFC_36PersonasAutorizadasMap = host + 'MapSolicitud/agregarMapFC_36_AnexoRepresentantesAutorizadosMap'
            const actualizarFC_36PersonasAutorizadasMap = host + 'MapSolicitud/actualizarMapFC_36_AnexoRepresentantesAutorizadosMap'
            const agregarFC_36RepresentanteLegalMap = host + 'MapSolicitud/agregarMapFC_36_AnexoRepresentantesLegalMap'
            const actualizarFC_36RepresentanteLegalMap = host + 'MapSolicitud/actualizarMapFC_36_AnexoRepresentantesLegalMap'
            const agregarFC_36PredioMap = host + 'MapSolicitud/agregarFC_36_PredioMap'
            const actualizarFC_36PredioMap = host + 'MapSolicitud/actualizarFC_36_PredioMap'
            const agregarFC_36ViveroMap = host + 'MapSolicitud/agregarFC_36_ViveroMap'
            const actualizarFC_36ViveroMap = host + 'MapSolicitud/actualizarFC_36_ViveroMap'
            const agregarFC_36MarcasMap = host + 'MapSolicitud/agregarFC_36_MarcasMap'
            const actualizarFC_36MarcasMap = host + 'MapSolicitud/actualizarFC_36_MarcasMap'
            const agregarFC_36MarcasBebidasMap = host + 'MapSolicitud/agregarFC_36_MarcasBebidasMap'
            const actualizarFC_36MarcasBebidasMap = host + 'MapSolicitud/actualizarFC_36_MarcasBebidasMap'
            const agregarFC_36InformacionGeneralMap = host + 'MapSolicitud/agregarFC_36_InformacionGeneralMap'
            const actualizarFC_36InformacionGeneralMap = host + 'MapSolicitud/actualizarFC_36_InformacionGeneralMap'
            const agregarFC_36ResponsablesInstalacionesMap = host + 'MapSolicitud/agregarFC_36_ResponsableInstalacionMap'
            const actualizarFC_36ResponsablesInstalacionesMap = host + 'MapSolicitud/actualizarFC_36_ResponsableInstalacionMap'
            const agregarFC_36DomicilioFiscalMap = host + 'MapSolicitud/agregarMapFC_36_AnexoDomiciliosFiscalMap'
            const actualizarFC_36DomicilioFiscalMap = host + 'MapSolicitud/actualizarMapFC_36_AnexoDomiciliosFiscalMap'
            const agregarFC_36ResponsablesInstMap = host + 'MapSolicitud/agregarFC_36_ActualizacionResponsablesInstalacionesMap'
            const actualizarFC_36ResponsablesInstMap = host + 'MapSolicitud/actualizarFC_36_ActualizacionResponsablesInstalacionesMap'

            const agregarFC_36ArchivoRepresentanteAutorizadoMap = host + 'MapSolicitud/agregarMapFC_36_ArchivosRepresentantesAutorizadosMap'
            const agregarFC_36ArchivoRepresentanteLegalMap = host + 'MapSolicitud/agregarMapFC_36_ArchivoRepresentantesLegalMap'
            const agregarFC_36ArchivoDomicilioFiscalMap = host + 'MapSolicitud/agregarMapFC_36_ArchivoDomiciliosFiscalMap'
            const agregarFC_36ArchivoPredioMap = host + 'MapSolicitud/agregarFC_36_ArchivosPredioMap'
            const agregarFC_36ArchivoViveroMap = host + 'MapSolicitud/agregarFC_36_ArchivosViveroMap'
            const agregarFC_36ArchivoMarcasMap = host + 'MapSolicitud/agregarFC_36_ArchivosMarcasMap'
            const agregarFC_36ArchivoMarcasBebidasMap = host + 'MapSolicitud/agregarFC_36_ArchivosMarcasBebidasMap'
            const agregarFC_36ArchivoInstalacionesMap = host + 'MapSolicitud/agregarFC_36_ArchivoInstalacionMap'
            const agregarFC_36ArchivoInstalacionesResponsablesMap = host + 'MapSolicitud/agregarFC_36_ArchivosResponsableInstalacionMap'
            const agregarFC_36ArchivoResponsablesInstMap = host + 'MapSolicitud/agregarFC_36_ArchivosActualizacionResponsablesInstalacionesMap'
            const actualizarFC_36ArchivoRepresentanteAutorizadoMap = host + 'MapSolicitud/actualizarMapFC_36_ArchivosRepresentantesAutorizadosMap'
            const actualizarFC_36ArchivoRepresentanteLegalMap = host + 'MapSolicitud/actualizarMapFC_36_ArchivoRepresentantesLegalMap'
            const actualizarFC_36ArchivoDomicilioFiscalMap = host + 'MapSolicitud/actualizarMapFC_36_ArchivoDomiciliosFiscalMap'
            const actualizarFC_36ArchivoPredioMap = host + 'MapSolicitud/actualizarFC_36_ArchivosPredioMap'
            const actualizarFC_36ArchivoViveroMap = host + 'MapSolicitud/actualizarFC_36_ArchivosViveroMap'
            const actualizarFC_36ArchivoMarcasMap = host + 'MapSolicitud/actualizarFC_36_ArchivosMarcasMap'
            const actualizarFC_36ArchivoMarcasBebidasMap = host + 'MapSolicitud/actualizarFC_36_ArchivosMarcasBebidasMap'
            const actualizarFC_36ArchivoInstalacionesMap = host + 'MapSolicitud/actualizarFC_36_ArchivoInstalacionMap'
            const actualizarFC_36ArchivoInstalacionesResponsablesMap = host + 'MapSolicitud/actualizarFC_36_ArchivosResponsableInstalacionMap'
            const actualizarFC_36ArchivoResponsablesInstMap = host + 'MapSolicitud/actualizarFC_36_ArchivosActualizacionResponsablesInstalacionesMap'

            const res = await axios.put(actualizarFC_36PricipalMap, observacionPrincipal)

            for (const i in mediosContactoMap) {
                if (mediosContactoMap?.[i]?.idfc36_anexomediodecontactomap != '') {
                    await axios.put(actualizarFC_36MediosContactoMap, { data: mediosContactoMap[i] })
                } else {
                    delete mediosContactoMap?.[i]?.idfc36_anexomediodecontactomap
                    await axios.post(agregarFC_36MediosContactoMap, { data: mediosContactoMap[i] })
                }
            }
            for (const i in personasAutorizadasMap) {
                if (personasAutorizadasMap?.[i]?.idfc36_anexopersonasautorizadasmap) {
                    await axios.put(actualizarFC_36PersonasAutorizadasMap, { data: personasAutorizadasMap[i] })
                } else {
                    delete personasAutorizadasMap?.[i]?.idfc36_anexopersonasautorizadasmap
                    await axios.post(agregarFC_36PersonasAutorizadasMap, { data: personasAutorizadasMap[i] })
                }
            }
            for (const i in representantesLegalesMap) {
                if (representantesLegalesMap?.[i].idfc36_anexoapoderadoslegalesmap) await axios.put(actualizarFC_36RepresentanteLegalMap, { data: representantesLegalesMap[i] })
                else {
                    delete representantesLegalesMap?.[i]?.idfc36_anexoapoderadoslegalesmap
                    await axios.post(agregarFC_36RepresentanteLegalMap, { data: representantesLegalesMap[i] })
                }
            }
            for (const i in domiciliosFiscalesMap) {
                if (domiciliosFiscalesMap?.[i]?.idfc36_anexodomiciliosfiscalesmap) await axios.put(actualizarFC_36DomicilioFiscalMap, { data: domiciliosFiscalesMap[i] })
                else {
                    delete domiciliosFiscalesMap?.[i]?.idfc36_anexodomiciliosfiscalesmap
                    await axios.post(agregarFC_36DomicilioFiscalMap, { data: domiciliosFiscalesMap[i] })
                }
            }
            for (const i in ResponsablesInstMap) {
                if (ResponsablesInstMap?.[i].idfc_36_actulizarresponsableinstalacionesmap) await axios.put(actualizarFC_36ResponsablesInstMap, { data: ResponsablesInstMap[i] })
                else {
                    delete ResponsablesInstMap?.[i].idfc_36_actulizarresponsableinstalacionesmap
                    await axios.post(agregarFC_36ResponsablesInstMap, { data: ResponsablesInstMap[i] })
                }
            }
            for (const i in marcasMap) {
                if (marcasMap?.[i]?.idfc36_anexomarcasmap) await axios.put(actualizarFC_36MarcasMap, { data: marcasMap[i] })
                else {
                    delete marcasMap?.[i]?.idfc36_anexomarcasmap
                    await axios.post(agregarFC_36MarcasMap, { data: marcasMap[i] })
                }
            }
            for (const i in marcasBebidasMap) {
                if (marcasBebidasMap?.[i]?.idfc36_anexomarcasproductoconmezcalmap) await axios.put(actualizarFC_36MarcasBebidasMap, { data: marcasBebidasMap[i] })
                else {
                    delete marcasBebidasMap?.[i]?.idfc36_anexomarcasproductoconmezcalmap
                    await axios.post(agregarFC_36MarcasBebidasMap, { data: marcasBebidasMap[i] })
                }
            }




            for (const i in prediosMap) {
                if (prediosMap?.[i]?.idfc36_anexoprediomap) await axios.put(actualizarFC_36PredioMap, { data: prediosMap[i] })
                else {
                    delete prediosMap?.[i]?.idfc36_anexoprediomap
                    await axios.post(agregarFC_36PredioMap, { data: prediosMap[i] })
                }
            }
            for (const i in viveroMap) {
                if (viveroMap?.[i]?.idfc_36_anexoviverosmap) await axios.put(actualizarFC_36ViveroMap, { data: viveroMap[i] })
                else {
                    delete viveroMap?.[i]?.idfc_36_anexoviverosmap
                    await axios.post(agregarFC_36ViveroMap, { data: viveroMap[i] })
                }
            }

            for (const i in InstalacionesDomicilioMap) {
                if (InstalacionesDomicilioMap?.[i].idfc_36informaciongeneralmap) await axios.put(actualizarFC_36InformacionGeneralMap, { data: InstalacionesDomicilioMap[i] })
                else await axios.post(agregarFC_36InformacionGeneralMap, { data: InstalacionesDomicilioMap[i] })
            }
            for (const i in InstalacionesResponsablesMap) {
                if (InstalacionesResponsablesMap?.[i].idfc_36responsabledeinstalacionmap) await axios.put(actualizarFC_36ResponsablesInstalacionesMap, { data: InstalacionesResponsablesMap[i] })
                else await axios.post(agregarFC_36ResponsablesInstalacionesMap, { data: InstalacionesResponsablesMap[i] })
            }
            for (const i in archivosRepresentanteLegalMap) {
                if (archivosRepresentanteLegalMap?.[i].idfc_36archivoresponsablelegalmap) await axios.put(actualizarFC_36ArchivoRepresentanteLegalMap, { data: archivosRepresentanteLegalMap[i] })
                else await axios.post(agregarFC_36ArchivoRepresentanteLegalMap, { data: archivosRepresentanteLegalMap[i] })
            }
            for (const i in archivosPersonasAutorizadasMap) {
                if (archivosPersonasAutorizadasMap?.[i].idfc_36archivopersonasautorizadasmap) await axios.put(actualizarFC_36ArchivoRepresentanteAutorizadoMap, { data: archivosPersonasAutorizadasMap[i] })
                else await axios.post(agregarFC_36ArchivoRepresentanteAutorizadoMap, { data: archivosPersonasAutorizadasMap[i] })
            }
            for (const i in archivosDomicilioFiscalMap) {
                if (archivosDomicilioFiscalMap?.[i]?.idfc_36archivodomiciliosfiscalesmap) await axios.put(actualizarFC_36ArchivoDomicilioFiscalMap, { data: archivosDomicilioFiscalMap[i] })
                else await axios.post(agregarFC_36ArchivoDomicilioFiscalMap, { data: archivosDomicilioFiscalMap[i] })
            }
            for (const i in archivosPrediosMap) {
                if (archivosPrediosMap?.[i]?.idfc_36archivoprediomap) await axios.put(actualizarFC_36ArchivoPredioMap, { data: archivosPrediosMap[i] })
                else await axios.post(agregarFC_36ArchivoPredioMap, { data: archivosPrediosMap[i] })
            }
            for (const i in archivosViverosMap) {
                if (archivosViverosMap?.[i]?.idfc_36archivoviveromap) await axios.put(actualizarFC_36ArchivoViveroMap, { data: archivosViverosMap[i] })
                else await axios.post(agregarFC_36ArchivoViveroMap, { data: archivosViverosMap[i] })
            }
            for (const i in archivosMarcasMap) {
                if (archivosMarcasMap?.[i].idarchivosmarcamap) await axios.put(actualizarFC_36ArchivoMarcasMap, { data: archivosMarcasMap[i] })
                else await axios.post(agregarFC_36ArchivoMarcasMap, { data: archivosMarcasMap[i] })
            }
            for (const i in archivosMarcasBebidasMap) {
                if (archivosMarcasBebidasMap?.[i].idarchivosmarcaproductomap) await axios.put(actualizarFC_36ArchivoMarcasBebidasMap, { data: archivosMarcasBebidasMap[i] })
                else await axios.post(agregarFC_36ArchivoMarcasBebidasMap, { data: archivosMarcasBebidasMap[i] })
            }
            for (const i in archivosInstalacionesMap) {
                if (archivosInstalacionesMap?.[i].idarchivosinstalacionmap) await axios.put(actualizarFC_36ArchivoInstalacionesMap, { data: archivosInstalacionesMap[i] })
                else await axios.post(agregarFC_36ArchivoInstalacionesMap, { data: archivosInstalacionesMap[i] })
            }
            for (const i in archivosResponsablesInstalacionesMap) {
                if (archivosResponsablesInstalacionesMap?.[i].idarchivosresponsablesmap) await axios.put(actualizarFC_36ArchivoInstalacionesResponsablesMap, { data: archivosResponsablesInstalacionesMap[i] })
                else await axios.post(agregarFC_36ArchivoInstalacionesResponsablesMap, { data: archivosResponsablesInstalacionesMap[i] })
            }

            for (const i in archivosResponsablesInstMap) {
                if (archivosResponsablesInstMap?.[i].idfc_36archivoresponsablesmap) await axios.put(actualizarFC_36ArchivoResponsablesInstMap, { data: archivosResponsablesInstMap[i] })
                else await axios.post(agregarFC_36ArchivoResponsablesInstMap, { data: archivosResponsablesInstMap[i] })
            }

            return true
        } catch (error) {
            console.log(error)
        }
    }
)


export const aceptarSolicitud = createAsyncThunk(
    ACEPTAR_FC_36_EXITO,
    async (data) => {
        try {
            const idcliente = data.idcliente
            const mediosContacto = data.fc_36_anexomediosdecontacto
            const responsablesLegales = data.fc_36_anexoapoderadoslegales
            const personasAutorizadas = data.fc_36_anexopersonasautorizadas
            const domicilioFical = data.fc_36_anexodomiciliosfiscales
            const marcas = data.fc_36_anexomarcas
            const marcasBebidas = data.fc_36_anexomarcasproductoconmezcal
            const viveros = data.fc_36_anexoviveros
            const predios = data.fc_36_anexopredio
            const responsableInst = data.fc_36_actualizacionresponsableinstalaciones
            const anexoInstalacion = data.fc_36anexo


            const urlActualizarCliente = host + 'InformacionValida/actualizarCliente'
            const urlAgregarMedioCliente = host + 'InformacionValida/agregarMediosDeContactoCliente'
            const urlActualizarMedioCliente = host + 'InformacionValida/actualizarMediosDeContactoCliente'
            const urlAgregarDomicilioFiscal = host + 'InformacionValida/agregarDomicilioFiscalCliente'
            const urlActualizarDomicilioFiscal = host + 'InformacionValida/actualizarDomicilioFiscalCliente'
            const urlAgregarInformacionPersonaFisica = host + 'InformacionValida/agregarInformacionPersonaFisicaCliente'
            const urlAgregarApoderadoLegal = host + 'InformacionValida/agregarApoderadosLegalesCliente'
            const urlActualizarApoderadoLegal = host + 'InformacionValida/actualizarApoderadosLegalesCliente'
            const urlAgregarRepresentanteAutorizado = host + 'InformacionValida/agregarRepresentantesAutorizadosCliente'
            const urlActualizarRepresentanteAutorizado = host + 'InformacionValida/actualizarRepresentantesAutorizadosCliente'
            const urlAgregarActividadCliente = host + 'InformacionValida/agregarActividadCliente'

            const urlAgregarPredio = host + 'InformacionValida/agregarPredioCliente'
            const urlActualizarPredio = host + 'InformacionValida/actualizarPredioCliente'
            const urlAgregarVivero = host + 'InformacionValida/agregarViveroCliente'
            const urlAtualizarVivero = host + 'InformacionValida/actualizarViveroCliente'
            const urlAgregarTipoPlantacion = host + 'InformacionValida/agregarTipoPlantacion'
            const urlAgregarMarcasCliente = host + 'InformacionValida/agregarMarcasCliente'
            const urlActualizarMarcasCliente = host + 'InformacionValida/actualizarMarcasCliente'
            const urlAgregarMarcasProductCliente = host + 'InformacionValida/agregarMarcasProductoConMezcalCliente'
            const urlActualizarMarcasProductCliente = host + 'InformacionValida/actualizarMarcasProductoConMezcalCliente'
            const urlAgregarInformacionGeneralInstalacionCliente = host + 'InformacionValida/agregarInformacionGeneralInstalacionCliente'
            const urlAgregarInstalacionCliente = host + 'InformacionValida/agregarInstalacionesCliente'
            const urlAgregarResponsableDeInstalacionCliente = host + 'InformacionValida/agregarResponsablesDeInstalacionCliente'
            const urlActualizarResponsableDeInstalacionCliente = host + 'InformacionValida/actualizarResponsablesDeInstalacionCliente'
            const urlAgregarAnexoCliente = host + 'InformacionValida/agregarAnexoCliente'
            const urlActualizarAnexoClienteByIdInformacionGeneralCliente = host + 'InformacionValida/actualizarAnexoClienteByIdInformacionGeneralCliente'
            const urlAgregarDataElementoCliente = host + 'InformacionValida/agregarDataElementoCliente'
            const actualizarSeccionesClienteByIdInformacionGeneralCliente = host + 'InformacionValida/actualizarSeccionesClienteByIdInformacionGeneralCliente'

            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'

            const actualizarEstadisticaSocialByidcliente = host + 'InformacionValida/actualizarEstadisticaSocialByidcliente'

            /*const urlActualizarApoderadosFile = host + 'InformacionValida/actualizarArchivoRepresentanteLegalCliente'
            const urlActualizarPersonasFile = host + 'InformacionValida/actualizarArchivosPersonaAutorizadaCliente'
            const urlActualizarDomicilioFile = host + 'InformacionValida/actualizarArchivosCliente'
            const urlActualizarViveroFile = host + 'InformacionValida/actualizarArchivoViverosCliente'
            const urlActualizarPredioFile = host + 'InformacionValida/actualizarArchivosPredioCliente'
            const urlActualizarMarcaFile = host + 'InformacionValida/actualizarArchivoMarcaCliente'
            const urlActualizarMarcaProductoFile = host + 'InformacionValida/actualizarArchivoMarcaProductoCliente'
            const urlActualizaResponsableFile = host + 'InformacionValida/actualizarArchivoResponsableInstalacionCliente'

        const urlObtenerAnexoCliente = host + 'InformacionValida/obtenerTodosAnexosClienteParaResponsable'*/
            if (data.actualizacioncadena) {
                console.log("entra en actualizacioncadena")
                let fullUrlDelete = host + `InformacionValida/eliminarActividadClienteByIdCliente/${idcliente}`
                await axios.delete(fullUrlDelete)
                if (data.viverista) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 1, idcliente: idcliente } })
                if (data.productormaguey) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 2, idcliente: idcliente } })
                if (data.productormezcal) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 3, idcliente: idcliente } })
                if (data.envasador) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 4, idcliente: idcliente } })
                if (data.comercializadormezcal) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 5, idcliente: idcliente } })
                if (data.comercializadorbebidas) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 6, idcliente: idcliente } })
            }
            if (data.cambiorazon) {
                for (const j in data.fc_36archivogeneral) {
                    const { idfc_36archivogeneral, idfc36_solicitudactualizacion,
                        idfc36_tipoanexo, fc_36archivodomiciliosficalesmap, ...restFile } = data.fc_36archivogeneral[j]
                    restFile.nombreTabla = 'archivosgeneralescliente'
                    restFile.nameFK = 'idcliente'
                    restFile.idFK = idcliente
                    restFile.observaciones = ''
                    await axios.post(urlAgregarFile, { data: restFile })
                }
                if (data.tipoempresa == "fisica") {
                    let empresaACertificar = ''
                    if (data.certificacionsi) empresaACertificar = data.empresacertificadora
                    else empresaACertificar = null
                    const dataFisica = {
                        personafisica: true, personamoral: false, nombrerazonsocial: data.actualizacionnombrerazon,
                        rfc: data.rfc, idcliente: idcliente, empresacertificadora: empresaACertificar
                    }
                    await axios.put(urlActualizarCliente, { data: dataFisica })
                    const dataInformacionFisica = {
                        fechadenacimiento: data.fechadenacimiento, sexo: data.sexo, estadocivil: data.estadocivil, escolaridad: data.escolaridad, discapacidadno: data.discapacidadno,
                        discapacidadsi: data.discapacidadsi, tipodiscapacidad: data.tipodiscapacidad, lenguaindijenasi: data.lenguaindijenasi, lenguaindijenano: data.medioscontactono,
                        tipolengua: data.tipolengua, ocupacion: data.ocupacion, numerohijos: data.numerohijos, idcliente: idcliente
                    }
                    const urlActualizarInformacionFisica = host + 'InformacionValida/actualizarInformacionPersonaFisicaClienteByCliente'
                    await axios.put(urlActualizarInformacionFisica, { data: dataInformacionFisica })

                }
                if (data.tipoempresa == "moral") {
                    let empresaACertificar = ''
                    if (data.certificacionsi) empresaACertificar = data.empresacertificadora
                    else empresaACertificar = null
                    const dataMoral = {
                        personafisica: false, personamoral: true, nombrerazonsocial: data.actualizacionnombrerazon,
                        rfc: data.rfc, idcliente: idcliente, empresacertificadora: empresaACertificar
                    }
                    await axios.put(urlActualizarCliente, { data: dataMoral })
                }
                const dataEstadistica = {
                    numerohombres: Number(data?.numerohombres), numeromujeres: Number(data?.numeromujeres), numerodiscapacitados: Number(data?.numerodiscapacitados),
                    numerobase: Number(data?.numerobase), numeroeventuales: Number(data?.numeroeventuales), idcliente:idcliente
                }
                await axios.put(actualizarEstadisticaSocialByidcliente, { data: dataEstadistica })

            }
            if (data.actualizarmedioscontacto) {
                for (const i in mediosContacto) {
                    const medio = mediosContacto[i]
                    if (medio.alta == true) {
                        const dataMedio = { telefono: medio.telefono, correoelectronico: medio.correoelectronico, idcliente: idcliente }
                        await axios.post(urlAgregarMedioCliente, { data: dataMedio })
                    }
                    if (medio.baja === true) {
                        const dataMedio = {
                            telefono: medio.telefono, correoelectronico: medio.correoelectronico, isbaja: true,
                            idmediosdecontacto: medio.relacioncontacto
                        }
                        await axios.put(urlActualizarMedioCliente, { data: dataMedio })
                    }

                }
            }
            if (data.cambiorepresentante) {
                for (const i in personasAutorizadas) {
                    const persona = personasAutorizadas[i]
                    if (persona.alta === true) {
                        const data = {
                            personaautoriazadaparatramites: persona.personaautoriazadaparatramites, telefonopersona: persona.telefono,
                            correoelectronicopersona: persona.correoelectronico, idcliente: idcliente, isbaja: false
                        }
                        const res = await axios.post(urlAgregarRepresentanteAutorizado, { data: data })
                        for (const j in persona.fc_36archivopersonasautorizadas) {
                            const { idfc36_anexopersonasautorizadas, idfc_36archivopersonasautorizadas, idfc36_tipoanexo, fc_36archivopersonasautorizadasmap, ...restFile } = persona.fc_36archivopersonasautorizadas[j]
                            restFile.nombreTabla = 'archivospersonasautorizadascliente'
                            restFile.nameFK = 'idrepresentantesautorizados'
                            restFile.idFK = res.data.data.idrepresentantesautorizados
                            restFile.observaciones = fc_36archivopersonasautorizadasmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }

                    if (persona.baja === true) {
                        const data = { idcliente: idcliente, isbaja: true, idrepresentantesautorizados: persona.relacioncontacto }
                        const res = await axios.put(urlActualizarRepresentanteAutorizado, { data: data })

                    }

                }
            }
            if (data.cambioresponsable) {
                for (const i in responsablesLegales) {
                    const responsable = responsablesLegales[i]
                    if (responsable.alta === true && responsable.principal == false) {
                        const data = {
                            representantelegal: responsable.representantelegal, telefonorepresentante: responsable.telefono,
                            correoelectronicorepresentante: responsable.correoelectronico, idcliente: idcliente
                        }
                        const resApoderado = await axios.post(urlAgregarApoderadoLegal, { data: data })
                        for (const j in responsable.fc_36archivoresponsablelegal) {
                            const { idfc36_anexoapoderadoslegales, idfc_36archivoresponsablelegal, idfc36_tipoanexo, fc_36archivoresponsablelegalmap, ...restFile } = responsable.fc_36archivoresponsablelegal[j]
                            restFile.nombreTabla = 'archivosapoderadoslegalescliente'
                            restFile.nameFK = 'idapoderadoslegales'
                            restFile.idFK = resApoderado.data.data.idapoderadoslegales
                            restFile.observaciones = fc_36archivoresponsablelegalmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (responsable.alta === true && responsable.principal == true && data.tipoempresa == 'moral') {
                        const data = {
                            nombrerepresentantelegal: responsable.representantelegal, telefonorepresentante: responsable.telefono,
                            correoelectronicorepresentante: responsable.correoelectronico, idcliente: idcliente
                        }
                        const resApoderado = await axios.put(urlActualizarCliente, { data: data })
                        for (const j in responsable.fc_36archivoresponsablelegal) {
                            const { idfc36_anexoapoderadoslegales, idfc_36archivoresponsablelegal, idfc36_tipoanexo, fc_36archivoresponsablelegalmap, ...restFile } = responsable.fc_36archivoresponsablelegal[j]
                            restFile.nombreTabla = 'archivosgeneralescliente'
                            restFile.nameFK = 'idcliente'
                            restFile.idFK = idcliente
                            restFile.observaciones = fc_36archivoresponsablelegalmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (data.tipoempresa == 'fisica') {
                        const data = {
                            nombrerepresentantelegal: '', telefonorepresentante: '',
                            correoelectronicorepresentante: '', idcliente: idcliente
                        }
                        await axios.put(urlActualizarCliente, { data: data })
                    }
                    if (responsable.baja === true && responsable.principal != true && data.tipoempresa == 'moral') {
                        const data = { isbaja: true, idcliente: idcliente, idapoderadoslegales: responsable.relacioncontacto }
                        await axios.put(urlActualizarApoderadoLegal, { data: data })

                    }
                }
            }
            if (data.actualizaciondomicilio) {
                for (const i in domicilioFical) {
                    const dato = domicilioFical[i]
                    if (dato.alta === true) {
                        const datas = {
                            codigopostal: dato.codigopostal, estado: dato.estado, municipioalcaldia: dato.municipio,
                            localidad: dato.localidad, colonia: dato.colonia, numerointerior: dato.numerointerior,
                            numeroexterior: dato.numeroexterior, calle: dato.calle, idcliente: idcliente, domicilioprincipal: dato.domicilioprincipal
                        }
                        await axios.post(urlAgregarDomicilioFiscal, { data: datas })
                        for (const j in dato.fc_36archivodomiciliosficales) {
                            const { idfc36_anexodomiciliosfiscales, idfc_36archivodomiciliosfiscales,
                                idfc36_tipoanexo, fc_36archivodomiciliosficalesmap, ...restFile } = dato.fc_36archivodomiciliosficales[j]
                            restFile.nombreTabla = 'archivosgeneralescliente'
                            restFile.nameFK = 'idcliente'
                            restFile.idFK = idcliente
                            restFile.observaciones = fc_36archivodomiciliosficalesmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }

                    if (dato.baja == true) {
                        const datas = { isbaja: true, idcliente: idcliente, iddomiciliofiscal: dato.relacioncontacto }
                        await axios.put(urlActualizarDomicilioFiscal, { data: datas })
                    }
                    if (dato.baja == false && dato.alta == false && !data.cambiorazon) {
                        const datas = { isbaja: false, idcliente: idcliente, iddomiciliofiscal: dato.relacioncontacto, domicilioprincipal: dato.domicilioprincipal }
                        await axios.put(urlActualizarDomicilioFiscal, { data: datas })
                    }
                    if (dato.baja == false && dato.alta == false && data.cambiorazon) {
                        const fullUrlObtener = host + `FC_36/eliminarArchivosGeneralesByidCliente/${idcliente}`
                        await axios.delete(fullUrlObtener)
                        for (const j in dato.fc_36archivodomiciliosficales) {
                            const { idfc36_anexodomiciliosfiscales, idfc_36archivodomiciliosfiscales,
                                idfc36_tipoanexo, fc_36archivodomiciliosficalesmap, ...restFile } = dato.fc_36archivodomiciliosficales[j]
                            restFile.nombreTabla = 'archivosgeneralescliente'
                            restFile.nameFK = 'idcliente'
                            restFile.idFK = idcliente
                            restFile.observaciones = fc_36archivodomiciliosficalesmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                }
            }
            if (data.cambioresponsableinst) {
                for (const i in responsableInst) {
                    const dato = responsableInst[i]
                    const fullUrl = host + `InformacionValida/obtenerTodosAnexosClientePorIdCliente/${idcliente}`
                    const res = await axios.get(fullUrl)

                    let filtroTipo = res?.data?.data?.filter(anexo => anexo.idtipoanexo == (dato.tipoinstalacion == 'Unidad de Produccion' ? 1 :
                        dato.tipoinstalacion == 'Unidad de Envasado' ? 2 : dato.tipoinstalacion == 'Unidad de Almacen' ? 3 : ''))
                    let filtroInstalacion = filtroTipo?.filter(anexo => anexo.informaciongeneralinstalacioncliente.alias == dato.alias)
                    let idiformaciongeneralcliente = filtroInstalacion?.[0]?.informaciongeneralinstalacioncliente?.idiformaciongeneralcliente
                    if (dato.alta === true) {
                        const datas = {
                            nombreresponsable: dato.nombreresponsable, telefono: dato.telefono,
                            correoelectronico: dato.correoelectronico, idiformaciongeneralcliente: idiformaciongeneralcliente,
                        }
                        const resA = await axios.post(urlAgregarResponsableDeInstalacionCliente, { data: datas })
                        for (const j in dato.fc_36archivoactualizacionresponsables) {
                            const { idfc_36_actulizarresponsableinstalaciones, idfc_36archivoresponsables,
                                idfc36_tipoanexo, fc_36archivoactualizacionresponsablesmap,
                                ...restFile } = dato.fc_36archivoactualizacionresponsables[j]
                            restFile.nombreTabla = 'archivosresposansablescliente'
                            restFile.nameFK = 'idresponsabledeinstalacioncliente'
                            restFile.idFK = resA.data.data.idresponsabledeinstalacioncliente
                            restFile.observaciones = fc_36archivoactualizacionresponsablesmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (dato.baja === true) {
                        const datas = { isbaja: true, idresponsabledeinstalacioncliente: dato.relacioncontacto }
                        const res = await axios.put(urlActualizarResponsableDeInstalacionCliente, { data: datas })
                    }
                }
            }
            if (data.actualizarmarcas || (data.actualizacioncadena && data.comercializadorbebidasaltabaja) || (data.cambiorazon && data.comercializadorbebidas)) {
                for (const i in marcasBebidas) {
                    let dato = marcasBebidas[i]
                    if (dato.alta == true) {
                        const datas = {
                            marca: dato.marca, numeroderegistroimpi: dato.numeroderegistroimpi, idtipomarca: dato.idtipomarca,
                            idtitularidaddemarca: dato.idtitularidaddemarca, registrosi: dato.registrosi, registrono: dato.registrono,
                            productor: dato.productor, maquilador: dato.maquilador, idcliente: idcliente,
                        }
                        const res = await axios.post(urlAgregarMarcasProductCliente, { data: datas })
                        for (const j in dato.fc_36_archivosmarcasproducto) {
                            const { idfc36_anexomarcasproductoconmezcal, idarchivosmarcaproducto,
                                idfc36_tipoanexo, fc_36_archivosmarcasproductomap, ...restFile } = dato.fc_36_archivosmarcasproducto[j]
                            restFile.nombreTabla = 'archivosmarcasproductocliente'
                            restFile.nameFK = 'idmarcasproductocliente'
                            restFile.idFK = res.data.data.idmarcasproductocliente
                            restFile.observaciones = fc_36_archivosmarcasproductomap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (dato.baja === true) {
                        const datas = { isbaja: true, idcliente: idcliente, idmarcasproductocliente: dato.relacioncontacto }
                        const res = await axios.put(urlActualizarMarcasProductCliente, { data: datas })
                    }
                }
            }
            if (data.actualizarmarcas || (data.actualizacioncadena && data.comercializadormezcalaltabaja) || (data.cambiorazon && data.comercializadormezcal)) {
                for (const i in marcas) {
                    let dato = marcas[i]
                    if (dato.alta == true) {
                        const datas = {
                            marca: dato.marca, numeroderegistroimpi: dato.numeroderegistroimpi, idtipomarca: dato.idtipomarca,
                            idtitularidaddemarca: dato.idtitularidaddemarca, registrosi: dato.registrosi, registrono: dato.registrono,
                            productor: dato.productor, maquilador: dato.maquilador, idcliente: idcliente,
                        }
                        const res = await axios.post(urlAgregarMarcasCliente, { data: datas })
                        for (const j in dato.fc_36_archivosmarcas) {
                            const { idfc36_anexomarcas, idarchivosmarca,
                                idfc36_tipoanexo, fc_36_archivosmarcasmap, ...restFile } = dato.fc_36_archivosmarcas[j]
                            restFile.nombreTabla = 'archivosmarcascliente'
                            restFile.nameFK = 'idmarcascliente'
                            restFile.idFK = res.data.data.idmarcascliente
                            restFile.observaciones = fc_36_archivosmarcasmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (dato.baja == true) {
                        const datas = { isbaja: true, idcliente: idcliente, idmarcascliente: dato.relacioncontacto }
                        const res = await axios.put(urlActualizarMarcasCliente, { data: datas })

                    }

                }
            }
            if (data.actualizacionprediosviveros || (data.actualizacioncadena && (data.viveristaaltabaja || data.productormagueyaltabaja)) || (data.cambiorazon && (data.viveristaaltabaja || data.productormagueyaltabaja))) {
                for (const i in predios) {
                    const dato = predios[i]
                    if (dato.alta == true) {
                        const datas = {
                            cultivado: dato.cultivado, semicultivado: dato.semicultivado, silvestre: dato.silvestre,
                            nombreparaje: dato.nombreparaje, localidad: dato.localidad, municipio: dato.municipio,
                            distrito: dato.distrito, estado: dato.estado, idcliente: idcliente,
                        }
                        const res = await axios.post(urlAgregarPredio, { data: datas })
                        console.log("")
                        for (const j in dato.fc_36archivopredio) {
                            const { idfc36_anexopredio, idfc_36archivopredio,
                                idfc36_tipoanexo, fc_36archivoprediomap, ...restFile } = dato.fc_36archivopredio[j]
                            restFile.nombreTabla = 'archivospredioscliente'
                            restFile.nameFK = 'idpredio'
                            restFile.idFK = res.data.data.idpredio
                            restFile.observaciones = fc_36archivoprediomap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (dato.baja == true) {
                        const datas = { isbaja: true, idcliente: idcliente, idpredio: dato.relacioncontacto }
                        const res = await axios.put(urlActualizarPredio, { data: datas })
                    }
                    if (dato.alta == false && dato.baja == false && data.cambiorazon) {
                        const urlEliminarArcivosPredioCliente = host + `FC_36/eliminarArchivosPredio/${dato.relacioncontacto}`
                        await axios.delete(urlEliminarArcivosPredioCliente)
                        for (const j in dato.fc_36archivopredio) {
                            const { idfc36_anexopredio, idfc_36archivopredio,
                                idfc36_tipoanexo, fc_36archivoprediomap, ...restFile } = dato.fc_36archivopredio[j]
                            restFile.nombreTabla = 'archivospredioscliente'
                            restFile.nameFK = 'idpredio'
                            restFile.idFK = dato.relacioncontacto
                            restFile.observaciones = fc_36archivoprediomap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                }

                for (const i in viveros) {
                    const dato = viveros[i]
                    if (dato.alta === true) {
                        const datas = {
                            cultivado: dato.cultivado, semicultivado: dato.semicultivado, silvestre: dato.silvestre,
                            nombreparaje: dato.nombreparaje, localidad: dato.localidad, municipio: dato.municipio,
                            distrito: dato.distrito, estado: dato.estado, calle: dato.calle, idcliente: idcliente,
                            numeroexterior: dato.numeroexterior, codigopostal: dato.codigopostal
                        }
                        const res = await axios.post(urlAgregarVivero, { data: datas })
                        for (const j in dato.fc_36archivovivero) {
                            const { idfc_36_anexoviveros, idfc_36archivovivero,
                                idfc36_tipoanexo, fc_36archivoviveromap, ...restFile } = dato.fc_36archivovivero[j]
                            restFile.nombreTabla = 'archivosviveroscliente'
                            restFile.nameFK = 'idvivero'
                            restFile.idFK = res.data.data.idvivero
                            restFile.observaciones = fc_36archivoviveromap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (dato.baja === true) {
                        const datas = { isbaja: true, idcliente: idcliente, idvivero: dato.relacioncontacto }
                        const res = await axios.put(urlAtualizarVivero, { data: datas })
                    }
                    if (dato.alta == false && dato.baja == false && data.cambiorazon) {
                        const urlEliminarArchivosViveroCliente = host + `FC_36/eliminarArchivosVivero/${dato.relacioncontacto}`
                        await axios.delete(urlEliminarArchivosViveroCliente)
                        for (const j in dato.fc_36archivovivero) {
                            const { idfc_36_anexoviveros, idfc_36archivovivero,
                                idfc36_tipoanexo, fc_36archivoviveromap, ...restFile } = dato.fc_36archivovivero[j]
                            restFile.nombreTabla = 'archivosviveroscliente'
                            restFile.nameFK = 'idvivero'
                            restFile.idFK = dato.relacioncontacto
                            //restFile.observaciones = fc_36archivoviveromap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                }
            }
            if (data.actualizacioninstalaciones || (data.actualizacioncadena && (data.productormezcalaltabaja || data.comercializadormezcalaltabaja || data.envasadoraltabaja))) {
                for (let i in anexoInstalacion) {
                    if (anexoInstalacion[i].alta) {
                        console.log("entro en alta ")
                        const { id, fc_36_dataelemento, fc_36_archivosinstalaciones, fc_36informaciongeneral,
                            tipoanexo, idtipoanexo, ...anexoInstalacionSinID } = anexoInstalacion[i]
                        console.log("entro en alta ", anexoInstalacion[i])
                        for (let x in anexoInstalacionSinID) {
                            if (anexoInstalacionSinID[x] === "") {
                                anexoInstalacionSinID[x] = null
                            }
                        }
                        const { idfc_36informaciongeneral, fc_36instalaciones, fc_36responsablesdeinstalacion, otracalle, anexoexistente, fc_36informaciongeneralmap, relacioncontacto, ...restoInformacionGeneral } = fc_36informaciongeneral
                        if (restoInformacionGeneral.calle === 'Otro') restoInformacionGeneral.calle = otracalle
                        const informacionGeneralClienteAgregada = await axios.post(urlAgregarInformacionGeneralInstalacionCliente, { data: restoInformacionGeneral })
                        const idiformaciongeneralcliente = informacionGeneralClienteAgregada.data.data.idiformaciongeneralcliente
                        for (const j in fc_36instalaciones) {
                            let dataInstalacion = {
                                idiformaciongeneralcliente: idiformaciongeneralcliente,
                                idtipoinstalacion: fc_36instalaciones[j].idtipoinstalacion,
                            }
                            await axios.post(urlAgregarInstalacionCliente, { data: dataInstalacion })
                        }
                        const data = {
                            idcliente: idcliente,
                            idtipoanexo: idtipoanexo,
                            idiformaciongeneralcliente: idiformaciongeneralcliente
                        }
                        const anexoAgregado = await axios.post(urlAgregarAnexoCliente, { data })
                        const idanexocliente = anexoAgregado.data.data.idanexocliente
                        for (const responsable of fc_36responsablesdeinstalacion) {
                            const { id, idfc_36informaciongeneral, idfc_36responsabledeinstalacion, fc_36_archivosresposansables, fc_36responsablesdeinstalacionmap, ...responsableSinID } = responsable
                            responsableSinID.idiformaciongeneralcliente = idiformaciongeneralcliente
                            const resResponsable = await axios.post(urlAgregarResponsableDeInstalacionCliente, { data: responsableSinID })
                            for (const j in fc_36_archivosresposansables) {
                                const { idarchivosresponsables, idfc_36responsabledeinstalacion, idfc36_tipoanexo, fc_36_archivosresposansablesmap, ...restFile } = fc_36_archivosresposansables[j]
                                restFile.nombreTabla = 'archivosresposansablescliente'
                                restFile.nameFK = 'idresponsabledeinstalacioncliente'
                                restFile.idFK = resResponsable.data.data.idresponsabledeinstalacioncliente
                                restFile.observaciones = fc_36_archivosresposansablesmap?.[0]?.observacion
                                await axios.post(urlAgregarFile, { data: restFile })
                            }
                        }

                        for (const element of fc_36_dataelemento) {
                            const { opcion, capacidad, idanexo, iddataelemento, elemento, idfc_36anexo, ...dataElemento } = element
                            dataElemento.idanexocliente = idanexocliente
                            await axios.post(urlAgregarDataElementoCliente, { data: dataElemento })
                        }
                        for (const j in fc_36_archivosinstalaciones) {
                            const { idarchivosinstalacion, idfc_36anexo, idfc36_tipoanexo, fc_36_archivosinstalacionesmap, ...restFile } = fc_36_archivosinstalaciones[j]
                            restFile.nombreTabla = 'archivosinstalacionescliente'
                            restFile.nameFK = 'idanexocliente'
                            restFile.idFK = idanexocliente
                            restFile.observaciones = fc_36_archivosinstalacionesmap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                    if (anexoInstalacion[i].baja) {
                        const { id, fc_36_dataelemento, fc_36_archivosinstalaciones, fc_36informaciongeneral,
                            tipoanexo, idtipoanexo, ...anexoInstalacionSinID } = anexoInstalacion[i]
                        const dataActualizacion = { isbaja: true, idiformaciongeneralcliente: fc_36informaciongeneral.relacioncontacto }
                        console.log("dataActualizacion ", dataActualizacion)
                        await axios.put(urlActualizarAnexoClienteByIdInformacionGeneralCliente, { data: dataActualizacion })

                    }

                    if (anexoInstalacion[i].isedicion) {
                        const { id, fc_36_dataelemento, fc_36_archivosinstalaciones, fc_36informaciongeneral,
                            tipoanexo, idtipoanexo, ...anexoInstalacionSinID } = anexoInstalacion[i]
                        const dataActualizacion = {
                            fc_36_dataelemento: fc_36_dataelemento, idiformaciongeneralcliente: anexoInstalacion[i].fc_36informaciongeneral.relacioncontacto,
                            alias: anexoInstalacion[i].fc_36informaciongeneral.alias
                        }
                        await axios.put(actualizarSeccionesClienteByIdInformacionGeneralCliente, { data: dataActualizacion })


                        /*const { id, fc_36_dataelemento, fc_36_archivosinstalaciones, fc_36informaciongeneral,
                        tipoanexo, idtipoanexo, ...anexoInstalacionSinID } = anexoInstalacion[i]
                    for (let x in anexoInstalacionSinID) {
                        if (anexoInstalacionSinID[x] === "") {
                            anexoInstalacionSinID[x] = null
                        }
                    }
                    const { idfc_36informaciongeneral, fc_36instalaciones, fc_36responsablesdeinstalacion, otracalle, anexoexistente, ...restoInformacionGeneral } = fc_36informaciongeneral
                    if (restoInformacionGeneral.calle === 'Otro') restoInformacionGeneral.calle = otracalle
                    const informacionGeneralClienteAgregada = await axios.post(urlAgregarInformacionGeneralInstalacionCliente, { data: restoInformacionGeneral })
                    const idiformaciongeneralcliente = informacionGeneralClienteAgregada.data.data.idiformaciongeneralcliente
                    
                    const idanexocliente = anexoAgregado.data.data.idanexocliente
                   
                    for (const element of dataelemento) {
                        const { opcion, capacidad, idanexo, iddataelemento, elemento, ...dataElemento } = element
                        dataElemento.idanexocliente = idanexocliente
                        await axios.post(urlAgregarDataElementoCliente, { data: dataElemento })
                    }*/
                    }
                    if (anexoInstalacion[i].alta == false && anexoInstalacion[i].baja == false && data.cambiorazon) {
                        const urlEliminarArcivosPredioCliente = host + `FC_36/eliminarArchivosInstalaciones/${anexoInstalacion[i].fc_36informaciongeneral.relacioncontacto}`
                        await axios.delete(urlEliminarArcivosPredioCliente)
                        for (const j in anexoInstalacion[i]?.fc_36_archivosinstalaciones) {
                            const { fc_36_archivosinstalacionesmap, idarchivosinstalacion, idfc36_tipoanexo,
                                idfc_36anexo, ...restFile } = anexoInstalacion[i]?.fc_36_archivosinstalaciones[j]
                            restFile.nombreTabla = 'archivosinstalacionescliente'
                            restFile.nameFK = 'idanexocliente'
                            restFile.idFK = idarchivosinstalacion
                            //restFile.observaciones = fc_36archivoprediomap?.[0]?.observacion
                            await axios.post(urlAgregarFile, { data: restFile })
                        }
                    }
                }
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerClienteDetalle = createAsyncThunk(
    OBTENER_CLIENTE_DETALLE_FC_36,
    async (idcliente) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClienteConDetalle/${idcliente}`
            const result = await axios.get(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarDocumentos = createAsyncThunk(
    GENERAR_OFICIOS_EXITO_FC_36,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFolio = createAsyncThunk(
    OBTENER_FOLIO_OFICIO_AT36,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerFolioOficio/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const enviarCorreo = createAsyncThunk(
    ENVIAR_CORREO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/enviarCorreoContratosFC_36'
            await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const enviarCorreoContrato = createAsyncThunk(
    ENVIAR_CORREO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/enviarCorreoContrato'
            await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_01PorLoginMap = createAsyncThunk(
    OBTENER_FC_01_POR_LOGIN_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `FC_01/obtenerFC_01PorLogin/${solicitudId}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_36Formulario = createAsyncThunk(
    ACTUALIZAR_FORMULARIO_FC36,
    async (data) => {
        try {
            const solicitud = { data: data }

            const actualizarFC_36 = host + 'FC_36/actualizarSolicitudFC_36'
            const res = await axios.put(actualizarFC_36, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_36Map = createAsyncThunk(
    OBTENER_FC_36_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_36_SolicitudDeActualizacionMap/${solicitudId}`
            const res = await axios.get(fullUrl)

            const anexosMap = await obtenerAnexosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                anexosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerAnexosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_36/obtenerUnaSolicitudFC_36Detalle/${idSolicitud}`
        const obtenerAnexoMarcasMap = host + `MapSolicitud/obtenerMapFC_36_AnexoMarcasMap/`
        const obtenerAnexoContactosMap = host + `MapSolicitud/obtenerMapFC_36_AnexoMediosDeContactoMap/`
        const obtenerAnexoRepresentantesMap = host + `MapSolicitud/obtenerMapFC_36_AnexoRepresentantesAutorizadosMap/`

        const res = await axios.get(fullUrl)
        let anexoMarcasMap = []
        let anexoContactosMap = []
        let anexoRepresentantesMap = []
        let anexoMarcasBajaMap = []
        let anexoContactosBajaMap = []
        let anexoRepresentantesBajaMap = []

        /*for(let i in res.data.data.fc_36_anexorepresentantesautorizados) {
            res.data.data.fc_36_anexorepresentantesautorizados[i]['id'] = uuidv4()  
            res.data.data.fc_36_anexorepresentantesautorizados[i].alta?altaRepresentante.push(res.data.data.fc_36_anexorepresentantesautorizados[i]):bajaRepresentante.push(res.data.data.fc_36_anexorepresentantesautorizados[i])
        }*/

        for (const anexo of res.data.data.fc_36_anexomarcas) {
            const resMap = await axios.get(obtenerAnexoMarcasMap + anexo.idfc36_anexomarcas)
            anexo.alta ? anexoMarcasMap.push(resMap.data.data) : anexoMarcasBajaMap.push(resMap.data.data)
        }
        for (const anexo of res.data.data.fc_36_anexomediosdecontacto) {
            const resMap = await axios.get(obtenerAnexoContactosMap + anexo.idfc36_anexomediodecontacto)
            anexo.alta ? anexoContactosMap.push(resMap.data.data) : anexoContactosBajaMap.push(resMap.data.data)
        }
        for (const anexo of res.data.data.fc_36_anexorepresentantesautorizados) {
            const resMap = await axios.get(obtenerAnexoRepresentantesMap + anexo.idfc36_anexorepresentantesautorizados)
            anexo.alta ? anexoRepresentantesMap.push(resMap.data.data) : anexoRepresentantesBajaMap.push(resMap.data.data)
        }

        let anexosMap = {
            anexoMarcasMap,
            anexoContactosMap,
            anexoRepresentantesMap,
            anexoMarcasBajaMap,
            anexoContactosBajaMap,
            anexoRepresentantesBajaMap
        }
        return anexosMap
    } catch (error) {
        console.log(error);
    }
}
export const obtenerFC_36UnidadAlmacenMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_36_AnexoUnidadDeAlmacenMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_36UnidadEnvasadoMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_36_AnexoUnidadDeEnvasadoMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_36UnidadProduccionMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_36_AnexoUnidadDeProduccionMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)


export const actualizarFC_36Estatus = createAsyncThunk(
    ACTUALIZAR_FC_36_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc36Slice = createSlice({
    name: 'fc36Slice',
    initialState: dataInicial,
    reducers: {
        setModoVerDetalleFC_36(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_36(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_36(state, { payload }) {
            state.modoProceso = payload
        },





        actualizarModoBorradorFC_36(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoRevisionFC_36(state, { payload }) {
            state.modoRevision = payload
        },
        actualizarModoCorrecionFC_36(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarPaginaActivaFC_36(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarPaginaActivaAlmacenFC_36(state, { payload }) {
            state.paginaActivaAlmacen = payload
        },
        actualizarPaginaActivaEnvasadoFC_36(state, { payload }) {
            state.paginaActivaEnvasado = payload
        },
        actualizarPaginaActivaProduccionFC_36(state, { payload }) {
            state.paginaActivaProduccion = payload
        },
        resetDataFC_36(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [obtenerFC_36SolicitudDetalle.fulfilled]: (state, { payload }) => {
            console.log("los datos de payload es ", payload)
            state.data = payload
            state.fc_36Map = payload?.fc_36_solicituddeactualizacionmap?.[0]
        },
        [obtenerFC_36Map.fulfilled]: (state, { payload }) => {
            state.fc_36Map = payload.data
            state.anexoMarcasMap = payload?.anexosMap?.anexoMarcasMap
            state.anexoContactosMap = payload?.anexosMap?.anexoContactosMap
            state.anexoRepresentantesMap = payload?.anexosMap?.anexoRepresentantesMap
            state.anexoMarcasBajaMap = payload?.anexosMap?.anexoMarcasBajaMap
            state.anexoContactosBajaMap = payload?.anexosMap?.anexoContactosBajaMap
            state.anexoRepresentantesBajaMap = payload?.anexosMap?.anexoRepresentantesBajaMap
        },
        [obtenerFC_36UnidadAlmacenMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadAlmacenMap = payload
        },
        [obtenerFC_36UnidadEnvasadoMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadEnvasadoMap = payload
        },
        [obtenerFC_36UnidadProduccionMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadProduccionMap = payload
        },
        [actualizarFC_36Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_36Estatus.fulfilled]: (state, { payload }) => {
        },
        [actualizarMapFC_36Accion.fulfilled]: (state, { payload }) => {
        },
        [agregarMapFC_36Accion.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },

    },
})

//actions
export const {
    setModoRecibidasCorregidasFC_36, setModoVerDetalleFC_36,
    setModoProcesoFC_36,


    actualizarModoBorradorFC_36,
    actualizarModoRevisionFC_36,
    actualizarModoCorrecionFC_36,
    actualizarPaginaActivaFC_36,
    actualizarPaginaActivaAlmacenFC_36,
    actualizarPaginaActivaEnvasadoFC_36,
    actualizarPaginaActivaProduccionFC_36,
    resetDataFC_36,
} = fc36Slice.actions

export const FC36ReducerAtencionACliente = fc36Slice.reducer